import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, ConfirmationOptions, GradeOptions } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/grade-courses/GradeCoursesAction";
import { useGradeCoursesUIContext } from "../GradeCoursesUIContext";

const prepareFilter = (queryParams, values) => {
  let { courseId, grade, credit, displayOnTheSchoolReport } = values;
  credit = credit === "" ? null : credit;
  const newQueryParams = { ...queryParams };
  const filter = { courseId, grade, credit, displayOnTheSchoolReport };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function GradeCoursesFilter() {
  // Grade Courses UI Context
  const coursesUIContext = useGradeCoursesUIContext();
  const coursesUIProps = useMemo(() => {
    return {
      setQueryParams: coursesUIContext.setQueryParams,
      queryParams: coursesUIContext.queryParams,
    };
  }, [coursesUIContext]);
  
  const dispatch = useDispatch();
  const { courses } = useSelector(
    (state) => ({
      courses: state.gradeCourses.courses
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getCourses());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(coursesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, coursesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      coursesUIProps.setQueryParams(newQueryParams);
    }
  };

  const gradeOptions = FilterOptions.concat(GradeOptions);
  const courseOptions = FilterOptions.concat(courses);
  
  return (
    <Formik
      initialValues={{
        credit: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={courseOptions}
                value={values.courseId}
                placeholder="Ders"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("courseId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Ders</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="credit"
                min={1}
                placeholder="Kredisi"
                onBlur={handleBlur}
                value={values.credit}
                onChange={(e) => {
                  setFieldValue("credit", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kredisi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={ConfirmationOptions}
                value={values.displayOnTheSchoolReport}
                placeholder="Karnede Görünsün mü?"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("displayOnTheSchoolReport", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Karnede Görünsün mü?</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}